<template>
    <div class="col-lg-auto">
        <div class="siderbar-right sidebar-style">
            <div class="sidebar-link">
                <h4>ACTION</h4>
                <ul>
                    <li>
                        <inertia-link :href="route('repository.add', {team: slug})">
                            <span><i class="feather-file-plus"></i></span>
                            <span>Add Hem Chart</span>
                        </inertia-link>
                    </li>
                    <li>
                        <a :href="route('repository-settings.members', {team: slug})">
                            <span><i class="feather-users"></i></span>
                            <span>Members</span>
                        </a>
                    </li>
                    <li>
                        <inertia-link :href="route('repository-settings.view', {team: slug})">
                            <span><i class="feather-settings"></i></span>
                            <span>Manage Repository</span>
                        </inertia-link>
                    </li>
                </ul>

                <div v-if="!showRepoAdd">
                    <h4 class="mb-0">Invite your team to collaborate with you</h4>
                    <a :href="route('repository-settings.members', {team: slug})" class="link-btn"><span>Invite team members</span><span><i class="feather-user-plus"></i></span></a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "RepositorySidebar",
        props: ['slug', 'showRepoAdd', 'username']
    }
</script>

<style scoped>

</style>
